// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__OwBhw","purchase_history":"_styles_purchase_history__vBaF5","pagination":"_styles_pagination__-rKES"};